onLoaded(() => {
	const megamenu = document.querySelector('#site-megamenu');
	if (!megamenu) return;

	const toggleButtons = [...document.querySelectorAll('[data-megamenu-open]')];
	const closeButtons = [...document.querySelectorAll('[data-megamenu-close]')];
	const backButton = megamenu.querySelector('[data-megamenu-level-back]');
	const parents = [...megamenu.querySelectorAll('.navbar-nav > .nav-item.dropdown')];
	const desktopMedia = window.matchMedia('(min-width: 992px)');
	let lastFocused = null;
	let submenuCloseTimer = null;

	const cancelSubmenuClose = () => {
		if (!submenuCloseTimer) return;

		clearTimeout(submenuCloseTimer);
		submenuCloseTimer = null;
	};

	const scheduleSubmenuClose = () => {
		if (!desktopMedia.matches) return;

		cancelSubmenuClose();

		submenuCloseTimer = setTimeout(() => {
			deactivateSubmenu();
			submenuCloseTimer = null;
		}, 120);
	};

	const setToggleState = isOpen => {
		toggleButtons.forEach(button => {
			button.setAttribute('aria-expanded', String(isOpen));

			const label = isOpen
				? button.dataset.closeLabel
				: button.dataset.openLabel;

			if (!label) return;

			button.setAttribute('aria-label', label);
			button.setAttribute('title', label);
		});
	};

	const deactivateSubmenu = () => {
		cancelSubmenuClose();

		parents.forEach(parent => {
			parent.classList.remove('is-submenu-active');

			const submenu = parent.querySelector(':scope > .dropdown-menu');
			const toggler = parent.querySelector(':scope > .dropdown-toggler');

			if (submenu) submenu.classList.remove('is-active');
			if (toggler) toggler.setAttribute('aria-expanded', 'false');
		});

		megamenu.classList.remove('has-submenu');
	};

	const activateSubmenu = parent => {
		if (!parent) return;

		const submenu = parent.querySelector(':scope > .dropdown-menu');
		const toggler = parent.querySelector(':scope > .dropdown-toggler');
		if (!submenu || !toggler) return;

		deactivateSubmenu();

		parent.classList.add('is-submenu-active');
		submenu.classList.add('is-active');
		toggler.setAttribute('aria-expanded', 'true');
		megamenu.classList.add('has-submenu');
	};

	const openMenu = () => {
		if (megamenu.classList.contains('is-open')) return;

		lastFocused = document.activeElement;

		megamenu.classList.add('is-open');
		megamenu.setAttribute('aria-hidden', 'false');
		document.body.classList.add('megamenu-open');

		setToggleState(true);
	};

	const closeMenu = () => {
		if (!megamenu.classList.contains('is-open')) return;

		deactivateSubmenu();

		megamenu.classList.remove('is-open');
		megamenu.setAttribute('aria-hidden', 'true');
		document.body.classList.remove('megamenu-open');

		setToggleState(false);

		if (lastFocused instanceof HTMLElement) lastFocused.focus();
	};

	const toggleMenu = () => {
		if (megamenu.classList.contains('is-open')) {
			closeMenu();
			return;
		}

		openMenu();
	};

	parents.forEach(parent => {
		const toggler = parent.querySelector(':scope > .dropdown-toggler');
		if (!toggler) return;

		toggler.removeAttribute('data-bs-toggle');
		toggler.removeAttribute('data-bs-auto-close');

		toggler.addEventListener('click', event => {
			event.preventDefault();
			event.stopPropagation();

			if (parent.classList.contains('is-submenu-active')) {
				deactivateSubmenu();
				return;
			}

			activateSubmenu(parent);
		});

		parent.addEventListener('mouseenter', () => {
			if (!desktopMedia.matches) return;

			cancelSubmenuClose();
			activateSubmenu(parent);
		});

		parent.addEventListener('mouseleave', scheduleSubmenuClose);

		const submenu = parent.querySelector(':scope > .dropdown-menu');

		if (submenu) {
			submenu.addEventListener('mouseenter', cancelSubmenuClose);
			submenu.addEventListener('mouseleave', scheduleSubmenuClose);
		}

		parent.addEventListener('focusin', () => {
			if (!desktopMedia.matches) return;

			cancelSubmenuClose();
			activateSubmenu(parent);
		});
	});

	toggleButtons.forEach(button => button.addEventListener('click', toggleMenu));
	closeButtons.forEach(button => button.addEventListener('click', closeMenu));

	if (backButton) backButton.addEventListener('click', deactivateSubmenu);

	document.addEventListener('keydown', event => {
		if (event.key !== 'Escape' || !megamenu.classList.contains('is-open')) return;

		if (megamenu.classList.contains('has-submenu')) {
			deactivateSubmenu();
			return;
		}

		closeMenu();
	});

	desktopMedia.addEventListener('change', deactivateSubmenu);
});
